module.exports = __webpack_public_path__ + "img/studyImga.3318d0c5.png";